import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h2 className="footer-logo">MINERVA</h2>
              <p className="footer-tagline">
                Inteligentna automatyzacja przyszłości
              </p>
              <div className="footer-social">
                <a href="#" className="social-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                  </svg>
                </a>
                <a href="#" className="social-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                    <rect x="2" y="9" width="4" height="12"></rect>
                    <circle cx="4" cy="4" r="2"></circle>
                  </svg>
                </a>
                <a href="#" className="social-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                  </svg>
                </a>
              </div>
            </div>
            
            <div className="footer-links">
              <div className="footer-links-column">
                <h3 className="footer-links-title">Produkty</h3>
                <ul className="footer-links-list">
                  <li><a href="#">MINERVA Edge</a></li>
                  <li><a href="#">MINERVA Central</a></li>
                  <li><a href="#">MCP Protocol</a></li>
                  <li><a href="#">Cennik</a></li>
                </ul>
              </div>
              
              <div className="footer-links-column">
                <h3 className="footer-links-title">Zasoby</h3>
                <ul className="footer-links-list">
                  <li><a href="#">Dokumentacja</a></li>
                  <li><a href="#">Baza wiedzy</a></li>
                  <li><a href="#">Blog</a></li>
                  <li><a href="#">Webinary</a></li>
                </ul>
              </div>
              
              <div className="footer-links-column">
                <h3 className="footer-links-title">Firma</h3>
                <ul className="footer-links-list">
                  <li><a href="#">O nas</a></li>
                  <li><a href="#">Zespół</a></li>
                  <li><a href="#">Praca</a></li>
                  <li><a href="#">Kontakt</a></li>
                </ul>
              </div>
            </div>
            
            <div className="footer-newsletter">
              <h3 className="footer-newsletter-title">Bądź na bieżąco</h3>
              <p>Zapisz się do naszego newslettera, aby otrzymywać najnowsze informacje o MINERVA</p>
              <div className="newsletter-form">
                <input type="email" placeholder="Twój adres email" className="newsletter-input" />
                <button className="newsletter-button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; 2025 MINERVA - Machine Intelligence Network for Edge-based Reasoning and Versatile Automation
            </p>
            <div className="footer-bottom-links">
              <a href="#">Polityka prywatności</a>
              <a href="#">Warunki korzystania</a>
              <a href="#">Pliki cookie</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;